<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="csts"
        :headers="headers"
        :rotina-id="ID_TELA_DE_CST"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarCST()"
        @update="(indice) => abrirDialogEditarCST(indice)"
        @delete="(indice) => openDialogDeleteCST(indice)"
      />
      <DialogDeEdicaoDeCST
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :cst-param="cstParam"
        :itens="itensParam"
        @confirmado="atualizarCST"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteCST" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="cstDelete">
            Tem certeza que deseja excluir o CST <b> {{ cstDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteCST = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerCST">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CSTService from '../../../services/cst/cst'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeCST from '../../../components/csts/DialogDeEdicaoDeCST'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import CST from '../../../models/cst'
import { ID_TELA_DE_CST } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeCST
  },
  data: () => ({
    name: 'TelaDeCST',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' }
    ],
    csts: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    cstParam: new CST(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteCST: false,
    cstDelete: new CST(),
    indiceCSTDelete: 0,
    ID_TELA_DE_CST: ID_TELA_DE_CST
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadCSTs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar CSTs cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadCSTs() {
      this.loading = true
      const response = await CSTService.getAll()
      this.csts = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarCST(cst) {
      if (!cst) return

      const indice = this.csts.findIndex((cstExistente) => cstExistente.id === cst.id)

      if (indice === -1) {
        this.csts.push(cst)
        this.snackbar.snackTextParam = 'CST criado com sucesso.'
      } else {
        this.csts.splice(indice, 1, cst)
        this.snackbar.snackTextParam = 'CST atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteCST(indice) {
      this.cstDelete = this.csts[indice]
      if (!this.cstDelete.id) return

      this.indiceCSTDelete = indice
      this.dialogDeleteCST = true
    },

    async removerCST() {
      try {
        await CSTService.deleteById(this.cstDelete.id)
        this.snackbar.snackTextParam = 'CST removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.csts.splice(this.indiceCSTDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteCST = false
    },

    abrirDialogCriarCST() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.cstParam = new CST()
      this.showDialogParam = true
    },

    abrirDialogEditarCST(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.cstParam = { ...this.csts[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
